const SA_NATIVE_TRANSFER_GAS_USED = 12000n
const SA_ERC20_TRANSFER_GAS_USED = 18000n
const GAS_TANK_TRANSFER_GAS_USED = 5000n

export { SA_NATIVE_TRANSFER_GAS_USED, SA_ERC20_TRANSFER_GAS_USED, GAS_TANK_TRANSFER_GAS_USED }
